import React from "react";
import classnames from "classnames/bind";

import styles from "./ErrorPlank.scss";

import strings from "../../locales/strings";

const cx = classnames.bind(styles);

const ErrorPlank = () => (
  <div className={cx("no-profile-plank")}>
    <span className={cx("no-profile-plank-text")}>
      {strings.serviceUnavailableCapitalize}
    </span>
  </div>
);

export default ErrorPlank;
